import { AbstractControl } from '@angular/forms';

export function shouldShowError(control: AbstractControl | null | undefined): boolean {
  return !!control && control.invalid && (control.touched || control.dirty);
}

export function getControlError(
  control: AbstractControl | null | undefined,
  field: 'email' | 'liquidationCode' | 'liquidationAmount' | 'phone' | 'conditions'
): string | null {
  if (!shouldShowError(control)) {
    return null;
  }

  if (control?.hasError('required') || control?.hasError('requiredTrue')) {
    return 'Campo obligatorio';
  }

  if (field === 'email' && control?.hasError('email')) {
    return 'Introduce un email válido';
  }

  if (field === 'liquidationAmount' && control?.hasError('min')) {
    return 'El importe debe ser mayor o igual que 0';
  }

  if (field === 'phone' && control?.hasError('minlength')) {
    return 'Introduce un teléfono válido (mínimo 9 dígitos)';
  }

  if (field === 'phone' && control?.hasError('mobilePhone')) {
    return 'Introduce un móvil válido de 9 dígitos (debe empezar por 6, 7 o 9).';
  }

  return 'Valor no válido';
}
